var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("header", { staticClass: "info-header" }, [
    _c("div", { staticClass: "info-header-content" }, [
      _setup.props.icon
        ? _c("div", { staticClass: "info-header-icon" }, [
            _c("img", { attrs: { src: _setup.props.icon, alt: "icon" } }),
          ])
        : _vm._e(),
      _c("div", { staticClass: "info-header-text" }, [
        _c("h2", { staticClass: "info-header-title" }, [
          _vm._v(_vm._s(_setup.props.title)),
        ]),
        _setup.props.subtitle
          ? _c("p", { staticClass: "info-header-subtitle" }, [
              _vm._v(_vm._s(_setup.props.subtitle)),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }